// extracted by mini-css-extract-plugin
export var bar = "sustainabilityArticles-module--bar--4da76";
export var img_container = "sustainabilityArticles-module--img_container--1c7b5";
export var products_cards = "sustainabilityArticles-module--products_cards--be1db";
export var slickDots = "sustainabilityArticles-module--slick-dots--2da5a";
export var slickSlider = "sustainabilityArticles-module--slick-slider--a4b42";